







































import Vue from 'vue';
import isGranted from '@/auth/isGranted';

export default Vue.extend({
  props: {
    companyId: {
      type: String,
      required: true,
    },
  },
  methods: {
    isGranted,
  },
});
